import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'dialogs-duplication',
    templateUrl: './dialogs-duplication.component.html',
    styleUrls: ['./dialogs-duplication.component.scss']
})
export class DialogsDuplicationComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<DialogsDuplicationComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
    }
}